import axios from "../api/axios";
import config from '../config/config';

function SendData(data, path) {
  var promise = new Promise(function (resolve, reject) {
    axios
      .post(config.endPoint + path, JSON.stringify(data), {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        withCredentials: true
      })
      .then((response) => {
        console.log(response);
        resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });

  return promise;
}

export function getUserById(id) {
  return new Promise((resolve, reject) => {
    SendData({ 'id': id }, 'api/auth/GetById')
      .then((data) => {
        resolve(data); 
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
}

export function authenticateUser(UserEmail, Password) {
  return new Promise((resolve, reject) => {
    SendData(
      {
        UserEmail: UserEmail,
        Password: Password,
      },
      'api/auth/Authenticate'
    )
      .then((data) => {
        resolve(data); 
      })
      .catch((err) => {
        console.log(err);
        reject(err); 
      });
  });
}

export function registerUser(Firstname, Lastname, UserEmail, Password) {
  return SendData({
        "Firstname": Firstname,
        "Lastname": Lastname,
        "UserEmail": UserEmail,
        "Password": Password,
        "RoleId": 1 // default USER role 
      }, '/api/auth/Register');
}

export function getAllUsers() {
  return new Promise((resolve, reject) => {
    axios
      .get(config.endPoint + '/api/auth/GetAll', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Methods': 'GET',
        },
        withCredentials: true
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export function updateUser(id, fName, lName, pwd, roleId) {
  return SendData({
    "Id": id,
    "FirstName": fName,
    "LastName": lName,
    "Password": pwd,
    "RoleId": roleId
  }, '/api/auth/UpdateUser');
}

export function deleteUser(id) {
  return SendData({
    "Id": id
  }, '/api/auth/DeleteUserById');
}

export function getAllRoles() {
  return new Promise((resolve, reject) => {
    axios
      .get(config.endPoint + '/api/auth/GetAllRoles', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Methods': 'GET',
        },
        withCredentials: true
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export function isTokenValid(token) {
  if (token === undefined) {
    return false;
  } else {
    const dateToCompare = new Date(token.expires);
    const currentDate = new Date();
    const currentDatePlus2Hours = new Date(currentDate.getTime() + 2 * 60 * 60 * 1000);
    if (dateToCompare > currentDatePlus2Hours) {
      return false;
    }
  }
  return true;
}
